import axios from 'axios';

import { API_URL, createHeaders } from '.'
import { SharedVideoData } from 'main/store/videos/selectors';

export const uploadVideo = async (data: SharedVideoData, token: string) => {
    await axios.post(`${API_URL}/videos`, data, createHeaders(token));
}

export const getAllThumbnails = async (token: string) => {
    const response = await axios.get(`${API_URL}/videos/thumbnails`, createHeaders(token));
    return response.data;
}
